import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Commons } from '../../../../shared/Commons';
import { OwnerConfig } from '../../../../shared/interfaces/core/owner-config';
import { environment } from '../../../../../environments/environment';
import { MdbModalModule, MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { SelectLanguageModalComponent } from '../../../../shared/modals/select-language-modal/select-language-modal.component';
import { SessionService } from '../../../../services/session.service';
import { CompaniesService } from '../../../../services/companies.service';
import { LanguageUtilService } from '../../../../services/language-util.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { StorageService } from '../../../../services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CdkService } from '../../../../services/cdk.service';
import { ScrollService } from '../../../../services/scroll.service';
import { ClientBrowserSessionStorageService } from '../../../../services/client-browser-session-storage.service';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { AlertModalComponent } from '../../../../shared/modals/alert-modal/alert-modal.component';
import { first } from 'rxjs';
import { CustomCommons } from '../../../../shared/CustomCommons';

/*
Can BE:
  ...
  templateUrl: './custom/{CUSTOM_COMPONENT_NAME}.component.html'
  styleUrls: ['./custom/{CUSTOM_COMPONENT_NAME}.component.scss']
  ...
*/
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    MdbModalModule
  ],
  templateUrl: './custom/header.component.html',
  styleUrl: './custom/header.component.scss'
})
export class HeaderComponent implements OnInit, AfterViewInit {

  ownerDetail: OwnerConfig = Commons.emptyOwnerConfig();
  NAVBAR_ALIGN_CENTER = Commons.NAVBAR_ALIGN_CENTER
  NAVBAR_ALIGN_RIGHT = Commons.NAVBAR_ALIGN_RIGHT
  NAVBAR_ALIGN_LEFT = Commons.NAVBAR_ALIGN_LEFT
  NAVBAR_TYPE_NORMAL = Commons.NAVBAR_TYPE_NORMAL
  NAVBAR_TYPE_TRANSPARENT = Commons.NAVBAR_TYPE_TRANSPARENT
  NAVBAR_TYPE_FLOATING = Commons.NAVBAR_TYPE_FLOATING
  PATH_ABOUT = '/' + Commons.PATH_ABOUT
  PATH_SERVICES = '/' + Commons.PATH_SERVICES
  PATH_TEAM = '/' + Commons.PATH_TEAM
  PATH_LOCATION = '/' + Commons.PATH_LOCATION
  PATH_CONTACT = '/' + Commons.PATH_CONTACT
  PATH_MY_CUSTOMER = '/' + Commons.PATH_MY_CUSTOMER
  PATH_PRODUCT = '/' + Commons.PATH_PRODUCT
  PATH_ADMIN_UI_KIT = '/' + Commons.PATH_ADMIN_UI_KIT
  PATH_LOGIN = '/' + Commons.PATH_LOGIN
  PATH_REGISTER = '/' + Commons.PATH_REGISTER
  PATH_PUBLICATIONS = '/' + Commons.PATH_PUBLICATIONS
  PATH_GALLERY = '/' + Commons.PATH_GALLERY
  isProduction = environment.production
  PATH_PRODUCT_SITE = environment.productSite
  withNavBarLogo = environment.withNavBarLogo
  webmailSite = environment.webmailSite
  enableWebmailSiteLink = environment.enableWebmailSiteLink
  getScreenWidth: any;
  mobileWidth: number = Commons.MOBILE_WIDTH
  sessionIsOpen: boolean | null = null
  sessionObject: any = null
  selLangModal: MdbModalRef<SelectLanguageModalComponent> | null = null;
  logoUrl: any
  DF_LOGO = environment.ownerId != 0 ? Commons.DF_COMPANY_LOGO : Commons.DF_PRODUCT_LOGO
  @ViewChild('mainNavbar', { static: true }) mainNavbar!: ElementRef;
  navBarAlign = environment.home.nav_bar_align
  navBarType = environment.home.nav_bar_type
  isTransparentNavOnScroll = this.isMobile ? true : false
  isSticky = this.navBarType !== this.NAVBAR_TYPE_NORMAL && this.navBarType !== this.NAVBAR_TYPE_TRANSPARENT;
  VIEW_TYPE_HOME = 'home'
  VIEW_TYPE_PAGE = 'page'
  showServiceType = environment.home.services
  showTeamType = environment.home.team
  showPublications = environment.home.publications
  showAboutUsType = environment.home.about_us
  showContactType = environment.home.contact
  showMapType = environment.home.map
  showGallery = environment.home.gallery
  isMenuOpen = false;
  isHovered = false;
  alertModal: MdbModalRef<AlertModalComponent> | null = null;
  PRODUCT_SITE = environment.productSite
  envTag = ''
  langBtnType = environment.home.lang_btn_type
  /* BEGIN | CUSTOM VARS */
  hover:boolean=false
  contactPhone=environment.dfConfigContactPhone
  contactMail=environment.dfConfigContactMail
  lastScrollPosition = 0;
  scrollThreshold = 100;
  PATH_DOCS = CustomCommons.PATH_DOCS
  PATH_SERVICE_STATUS = `/${CustomCommons.PATH_SERVICE_STATUS}`
  PATH_SERVICE_STATUS_ADMIN = `${environment.integrations.checkservices.backendEndpoint}/admin/login/?next=/admin/`
  PATH_STORE = environment.coreFrontendEndpoint
  PATH_EE_REGISTER = `${environment.coreFrontendEndpoint}/register`
  /* END | CUSTOM VARS */

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private companiesService: CompaniesService,
    private modalService: MdbModalService,
    private langService: LanguageUtilService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private sanitizer: DomSanitizer,
    private cdkService: CdkService,
    private scrollService: ScrollService,
    private eRef: ElementRef,
    private sessionStorageService: ClientBrowserSessionStorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdRef: ChangeDetectorRef
    /* BEGIN | CUSTOM ARGS */
    /* END | CUSTOM ARGS */
  ) {
    this.sessionObject = Commons.sessionObject(sessionStorageService)
  }

  ngOnInit(): void {
    /* BEGIN | CUSTOM CODE */
    /* END | CUSTOM CODE */
    this.buildEnvTag();
    if ((this.isBrowser)) {
      this.sessionIsOpen = Commons.sessionIsOpen(this.sessionStorageService)
      this.cdRef.detectChanges();
    }
    this.loadOwnerConfig()
    this.getScreenWidth = this.isBrowser ? window.innerWidth : Commons.MOBILE_WIDTH + 1
    this.isBrowser && window.addEventListener('scroll', this.onWindowScroll);
    this.loadLogo()
  }

  ngOnDestroy() {
    this.isBrowser && window.removeEventListener('scroll', this.onWindowScroll);
  }

  @HostListener('window:scroll', [])
  onWindowScroll = () => {
    if (this.isBrowser) {
      const scrollOffset = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      this.isSticky = this.navBarType === this.NAVBAR_TYPE_NORMAL ? scrollOffset > 0 : true;

      const previous = this.isTransparentNavOnScroll;

      this.isTransparentNavOnScroll =
        this.navBarType === this.NAVBAR_TYPE_TRANSPARENT && scrollOffset > 0
          ? true
          : this.isMobile
            ? true
            : false;

      if (previous !== this.isTransparentNavOnScroll) {
        this.cdRef.detectChanges(); // <-- fuerza re-render
      }
    }
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => this.onWindowScroll(), 0);
      window.addEventListener('scroll', this.onWindowScroll);

      const elements = document.querySelectorAll('.nav-link');
      const effect = environment.home.nav_bar_effect;

      elements.forEach((element) => {
        element.addEventListener('mousemove', () => {
          element.classList.add(effect);
        });
        element.addEventListener('mouseout', () => {
          element.classList.remove(effect);
        });
      });
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.getScreenWidth = this.isBrowser ? window.innerWidth : Commons.MOBILE_WIDTH + 1
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (this.isBrowser && this.isMenuOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.closeNavbar()
    }
  }

  loadOwnerConfig() {
    if (this.isBrowser) {
      this.route.queryParams.pipe(first()).subscribe(params => {
        const subdomain = params['subdomain']
        const validated = Commons.getOwner(this.sessionStorageService)
        const ownerIdentifier = (environment.ownerId != 0) ? environment.ownerId : subdomain
        if (validated == null) {
          //load from endpoint
          if (ownerIdentifier) {
            this.companiesService.getOwner(ownerIdentifier).subscribe(
              {
                next: async (v) => {
                  const owner = await this.cdkService.getTrxDec(v.trx)
                  this.ownerDetail = owner.config
                  Commons.setOwner(this.sessionStorageService, owner)
                  setTimeout(() => {
                    this.isBrowser && window.location.reload();
                  }, 1000);
                },
                error: () => {
                  this.ownerDetail = Commons.getDefaultConfig()
                },
                complete: () => { }
              }
            )
          }
        } else {
          this.ownerDetail = validated.config
        }
      })
    }
  }

  closeSession() {
    if (Commons.sessionIsOpen(this.sessionStorageService)) {
      this.sessionService.setUserLoggedIn(false);
      Commons.sessionClose(this.sessionStorageService)
      this.router.navigate([Commons.PATH_MAIN]).then(() => {
        this.isBrowser && window.location.reload();
      });
    }
  }

  openModal(title: string, message: string, icon: string) {
    this.alertModal = this.modalService.open(AlertModalComponent, {
      data: { title: title, message: message, icon: icon },
    })
  }

  openLanguageModal() {
    if (this.router.url.endsWith(Commons.PATH_MY_CUSTOMER)) {
      this.openModal('label.action-not-allowed', 'label.language-selector-not-allowed', Commons.ICON_INFO)
      return
    }

    this.selLangModal = this.modalService.open(SelectLanguageModalComponent)
    this.selLangModal.onClose.subscribe((lang: any) => {
      if (lang != this.langService.getLangActive()) {
        this.langService.setLanguage(lang)
        this.isBrowser && window.location.reload();
      }
    });
  }

  getCustomerName() {
    let name = 'NO-NAME'
    if (this.sessionObject.customer) {
      name = this.sessionObject.customer.email
      if (this.sessionObject.customer.personal_data) {
        name = this.sessionObject.customer.personal_data.first_name
        if (this.sessionObject.customer.personal_data.last_name) {
          name = name + ' ' + this.sessionObject.customer.personal_data.last_name
        }
      }
    }
    return name
  }

  get isProductSite() {
    return environment.ownerId == 0
  }

  get appName() {
    return environment.appName
  }

  loadLogo() {
    this.logoUrl = this.sanitizer.bypassSecurityTrustUrl(this.DF_LOGO)
    if (Commons.validField(Commons.getOwner(this.sessionStorageService))) {
      this.storageService.getCompanyLogoByOwnerId(Commons.getOwner(this.sessionStorageService).id).subscribe(
        {
          next: async (v) => {
            this.logoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(v))
          },
          error: (e) => {
            this.logoUrl = this.sanitizer.bypassSecurityTrustUrl(this.DF_LOGO)
          },
          complete: () => { }
        }
      )
    }
  }

  closeNavbar(): void {
    // Encuentra el elemento del menú desplegable y ciérralo
    this.isMenuOpen = false;
    this.isHovered = false;
  }

  get isMobile() {
    return this.getScreenWidth < this.mobileWidth
  }

  private goToSection(section: string) {
    this.scrollService.goToSection(this.router, section);
  }

  onClickInitHome() {
    this.goToSection(Commons.SCROLLABLE_INITHOME)
  }

  onClickServices() {
    this.goToSection(Commons.SCROLLABLE_SERVICES)
  }

  onClickTeam() {
    this.goToSection(Commons.SCROLLABLE_TEAM)
  }

  onClickAboutUs() {
    this.goToSection(Commons.SCROLLABLE_ABOUTUS)
  }

  onClickContact() {
    this.goToSection(Commons.SCROLLABLE_CONTACT)
  }

  onClickMap() {
    this.goToSection(Commons.SCROLLABLE_MAP)
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen; // Alterna entre abierto/cerrado
  }

  hoverIcon(state: boolean) {
    this.isHovered = state; // Activa/desactiva hover
  }

  get isBrowser() {
    return Commons.isBrowser(this.platformId);
  }

  buildEnvTag() {
    if(this.PRODUCT_SITE.includes('dev')) {
      this.envTag = 'Dev'
    } else if(this.PRODUCT_SITE.includes('intg')) {
      this.envTag = 'Beta'
    } else {
      this.envTag = ''
    }
  }

  getLangSelected() {
    return this.langService.getLangActive()
  }

  /* BEGIN | CUSTOM FUNCTIONS */
  /* END | CUSTOM FUNCTIONS */

}
